// Media Machine Platform Configuration
export default {
  appName: process.env.VUE_APP_TENANT_NAME || 'Media Machine',
  companyName: 'Contech Media',
  footer: '© Contech Media Ltd, Mauritius',
  logoUrl: '/img/logo.png',
  environment: {
    development: {
      apiUrl: 'http://localhost:3002'
    },
    production: {
      apiUrl: process.env.VUE_APP_API_URL || 'https://mediamachine.eu-4.evennode.com'
    }
  }
}
